import React from "react";
import "./Careers.css";
import { Link } from "react-router-dom";

function Careers() {
  return (
    <div className="careers-page">
      {/* HERO / HEADER SECTION */}
      <header className="header-section fade-in-up">
        <div className="header-badge">We&apos;re Hiring • Multiple Roles</div>
        <h1 className="header-title gradient-title">
          Join Our Team
        </h1>
        <p className="header-subtitle">
          Collaborate, innovate, and grow with a team dedicated to building
          real-world software products across web, mobile, cloud and AI.
        </p>

        <div className="header-stats">
          <div className="stat-card">
            <span className="stat-number">15+</span>
            <span className="stat-label">Active Projects</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">5+</span>
            <span className="stat-label">Tech Roles Open</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">100%</span>
            <span className="stat-label">Growth Mindset</span>
          </div>
        </div>
      </header>

      {/* OPEN ROLES SECTION */}
      {/* <section className="job-listings-section fade-in-up delay-1">
        <div className="section-heading">
          <h2 className="section-title with-underline">Open Positions</h2>
          <p className="section-subtitle">
            We are looking for makers, problem-solvers, and product thinkers who
            love shipping clean, reliable software.
          </p>
        </div>

        <div className="job-listings">
          <div className="job-card fade-in-up delay-1">
            <h2 className="job-title">Frontend Developer</h2>
            <p className="job-description">
              Build responsive, pixel-perfect UIs with React and modern
              JavaScript tooling.
            </p>
            <div className="job-meta">
              <span>Experience: 0–2 years</span>
              <span>Location: On-site</span>
              <span>Type: Full-time</span>
            </div>
            <div className="job-tags">
              <span>React</span>
              <span>TypeScript</span>
              <span>CSS / Tailwind</span>
            </div>
            <Link to="/contact">
            <button type="button" className="apply-button">
              Apply Now
            </button>
            </Link>
          </div>

          <div className="job-card fade-in-up delay-2">
            <h2 className="job-title">Backend Developer</h2>
            <p className="job-description">
              Design RESTful APIs and robust services that scale with real user
              traffic.
            </p>
            <div className="job-meta">
              <span>Experience: 0–2 years</span>
              <span>Location: On-site</span>
              <span>Type: Full-time</span>
            </div>
            <div className="job-tags">
              <span>Node.js</span>
              <span>Express</span>
              <span>PostgreSQL</span>
            </div>
            <Link to="/contact">
            <button type="button" className="apply-button">
              Apply Now
            </button>
            </Link>
          </div>

          <div className="job-card fade-in-up delay-3">
            <h2 className="job-title">Full Stack Developer</h2>
            <p className="job-description">
              Translate ideas and flows into intuitive interfaces and
              high-fidelity prototypes.
            </p>
            <div className="job-meta">
              <span>Experience: 1–2 years</span>
              <span>Location:On-site</span>
              <span>Type: Full-time</span>
            </div>
            <div className="job-tags">
              <span>Figma</span>
              <span>Design Systems</span>
              <span>Prototyping</span>
            </div>
            <Link to="/contact">
            <button type="button" className="apply-button">
              Apply Now
            </button>
            </Link>
          </div>
        </div>
      </section> */}

      {/* LIFE AT COMPANY SECTION */}
      <section className="life-section fade-in-up delay-2">
        <div className="section-heading">
          <h2 className="section-title with-underline">Life at Our Company</h2>
          <p className="section-subtitle">
            We work like a focused product team: small squads, real ownership,
            and constant learning.
          </p>
        </div>

        <div className="life-grid">
          <div className="life-card">
            <div className="life-icon">🤝</div>
            <h3>Ownership Culture</h3>
            <p>
              You don&apos;t just take tasks — you own features from idea to
              deployment and monitoring.
            </p>
          </div>
          <div className="life-card">
            <div className="life-icon">📚</div>
            <h3>Continuous Learning</h3>
            <p>
              Regular knowledge-sharing, code reviews, and access to courses and
              tools.
            </p>
          </div>
          <div className="life-card">
            <div className="life-icon">🧠</div>
            <h3>Real Product Impact</h3>
            <p>
              Work on ERP, SaaS, mobility and AI projects used by real
              customers, not dummy apps.
            </p>
          </div>
          <div className="life-card">
            <div className="life-icon">🌍</div>
            <h3>Modern Tech Stack</h3>
            <p>
              React, Node.js, PostgreSQL, cloud &amp; automation — practical
              tools that matter.
            </p>
          </div>
        </div>
      </section>

      {/* HIRING PROCESS SECTION */}
      <section className="process-section fade-in-up delay-3">
        <div className="section-heading">
          <h2 className="section-title with-underline">Our Hiring Process</h2>
          <p className="section-subtitle">
            Simple, transparent, and focused on how you think, build, and
            collaborate.
          </p>
        </div>

        <div className="process-timeline">
          <div className="process-step">
            <span className="step-badge">1</span>
            <h3>Apply Online</h3>
            <p>
              Share your resume, portfolio, and a short note about your ideal
              role and tech area.
            </p>
          </div>
          <div className="process-step">
            <span className="step-badge">2</span>
            <h3>Intro Conversation</h3>
            <p>
              A quick call to understand your experience, expectations and
              preferred way of working.
            </p>
          </div>
          <div className="process-step">
            <span className="step-badge">3</span>
            <h3>Technical / Design Round</h3>
            <p>
              Practical discussion or mini-task based on challenges from our
              actual projects.
            </p>
          </div>
          <div className="process-step">
            <span className="step-badge">4</span>
            <h3>Offer &amp; Onboarding</h3>
            <p>
              If there&apos;s a fit, we extend an offer and guide you through a
              structured onboarding plan.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA SECTION */}
      <section className="careers-cta fade-in-up delay-4">
        <div className="careers-cta-inner">
          <div>
            <h2>Didn&apos;t find a perfect role?</h2>
            <p>
              We are always happy to meet engineers, designers and product
              people who love building. Share your profile – we&apos;ll reach
              out when something matches.
            </p>
          </div>
          <Link to="/contact">
          <button type="button" className="apply-button apply-outline">
            Send Your Resume
          </button>
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Careers;
